import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import formatDate from "../../common/Formatdate";
import formatDateAndTime from "../../common/formatDateAndTime";
import EditIcon from "@mui/icons-material/Edit";
import ImagePreviewLoop from "../../common/imagepreviewloop";

const Insurance = ({
  workOrderDetail,
  insurancePostReponse,
  setInsurancePostResponse,
  // handleImageOpen,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [formData, setFormData] = useState({
    claimNumber: "",
    vehicleId: "",
    serviceId: "",
    policyNumber: "",
    agentName: "",
    isuranceProvider: "",
    contactNumber: "",
    contactEmail: "",
    estimatedAmount: null,
    approvedAmount: null,
    policyDocument: [],
    attachments: [],
    currentStatus: "",
    claimDate: "",
    remark: "",
    dispurseDate: "",
    statusChangedTo: "",
    attachmentsClaim: [],
  });
  const [insuranceClaimHistories, setInsuranceClaimHistories] = useState([]);
  const [isEditingApprovedAmount, setIsEditingApprovedAmount] = useState(false);
  const [isEditingClaimDate, setIsEditingClaimDate] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const [openImage, setOpenImage] = useState(false);
  const [imageSelection, setImageSelection] = useState(null);

  const parseImages = (value) => {
    try {
      if (!value) return [];

      if (Array.isArray(value)) return value;

      const parsed = typeof value === "string" ? JSON.parse(value) : value;

      if (Array.isArray(parsed)) return parsed;

      if (typeof parsed === "object") return [parsed];

      return [];
    } catch (e) {
      return [];
    }
  };

  const handleFileChange = async (files, field) => {
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded || [];

    setFormData((prev) => ({
      ...prev,
      [field]: [...(prev[field] || []), ...uploaded],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // simple validation
    const {
      insuranceId,
      insuranceCompany,
      amountClaimed,
      amountDispersed,
      claimDate,
      dispersedDate,
    } = formData;

    if (
      !insuranceId ||
      !insuranceCompany ||
      !amountClaimed ||
      !amountDispersed ||
      !claimDate ||
      !dispersedDate
    ) {
      alert("Please fill all required fields");
      return;
    }
  };

  const validateInsuranceClaim = () => {
    if (!formData?.claimNumber) return "Claim number is required";
    if (!formData?.policyNumber) return "Policy number is required";
    if (!formData?.isuranceProvider) return "Insurance provider is required";
    // if (!formData?.currentStatus) return "Current status is required";
    if (!formData?.claimDate) return "Claim date is required";

    // Contact validation
    if (!formData.contactNumber) {
      return "Contact number is required";
    }

    if (!/^[6-9]\d{9}$/.test(formData.contactNumber)) {
      return "Enter a valid 10-digit contact number";
    }

    if (!formData.contactEmail) {
      return "Email is required";
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.contactEmail)) {
      return "Enter a valid email address";
    }

    // Amount validation
    // if (formData?.estimatedAmount && Number(formData.estimatedAmount) < 0) {
    //   return "Estimated amount cannot be negative";
    // }

    // if (formData?.approvedAmount && Number(formData.approvedAmount) < 0) {
    //   return "Approved amount cannot be negative";
    // }

    // if (
    //   formData?.estimatedAmount &&
    //   formData?.approvedAmount &&
    //   Number(formData.approvedAmount) > Number(formData.estimatedAmount)
    // ) {
    //   return "Approved amount cannot exceed estimated amount";
    // }

    // Date validation
    if (
      !formData?.dispurseDate &&
      !formData?.claimDate &&
      formData.dispurseDate < formData.claimDate
    ) {
      return "Disburse date cannot be before claim date";
    }

    if (!formData?.attachments || formData.attachments.length === 0) {
      return "At least one attachment is required";
    }

    return null;
  };

  const handleAddInsuranceClaim = async () => {
    const error = validateInsuranceClaim();

    if (error) {
      toast.error(error);
      return;
    }
    let payload = {
      claimNumber: formData?.claimNumber,
      vehicleId: workOrderDetail?.vehicleId,
      serviceId: workOrderDetail?.id,
      policyNumber: formData?.policyNumber,
      agentName: formData?.agentName,
      isuranceProvider: formData?.isuranceProvider,
      contactNumber: formData?.contactNumber,
      contactEmail: formData?.contactEmail,
      estimatedAmount: Number(formData?.estimatedAmount),
      approvedAmount: Number(formData?.approvedAmount),
      policyDocument: JSON.stringify(formData?.policyDocument),
      attachments: JSON.stringify(formData?.attachments),
      currentStatus: formData?.currentStatus,
      claimDate: formData?.claimDate,
      dispurseDate: formData?.dispurseDate,
    };
    // return;
    try {
      const response = await fetch(`${apiUrl}/api/insuranceclaims`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Insurance Claim Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setInsurancePostResponse(data?.dataValues);
        // await handleAddInsuranceClaimHistories(data?.dataValues);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const handleAddInsuranceClaimHistories = async () => {
    let payload = {
      claimId: insurancePostReponse?.id,
      statusChangedTo: formData?.statusChangedTo,
      remark: formData?.remark,
      attachment: JSON.stringify(formData?.attachmentsClaim),
    };
    // return;
    try {
      const response = await fetch(`${apiUrl}/api/insuranceclaimhistories`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setFormData({
          claimNumber: "",
          vehicleId: "",
          serviceId: "",
          policyNumber: "",
          agentName: "",
          isuranceProvider: "",
          contactNumber: "",
          contactEmail: "",
          estimatedAmount: null,
          approvedAmount: null,
          policyDocument: [],
          attachments: [],
          currentStatus: "",
          claimDate: "",
          remark: "",
          dispurseDate: "",
          statusChangedTo: "",
          attachmentsClaim: [],
        });
        await getInsuranceClaimDetails();
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const getInsuranceClaimDetails = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/insuranceclaims?serviceId=${workOrderDetail?.id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setInsurancePostResponse(data?.entities?.rows[0]);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getInsuranceClaimHistoriesDetails = async (id) => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/insuranceclaimhistories?claimId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setInsuranceClaimHistories(data?.entities?.rows);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    if (workOrderDetail?.id) {
      getInsuranceClaimDetails(workOrderDetail?.id);
    }
  }, [workOrderDetail]);

  useEffect(() => {
    if (insurancePostReponse?.id) {
      getInsuranceClaimHistoriesDetails(insurancePostReponse?.id);
    }
  }, [insurancePostReponse]);

  const handleUpdateInsuranceClaim = async () => {
    let payload = {
      id: insurancePostReponse?.id,
      approvedAmount: Number(formData?.approvedAmount),
      claimDate: formData?.claimDate,
    };
    // return;
    try {
      const response = await fetch(`${apiUrl}/api/insuranceclaims`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Insurance Claim Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setIsEditingApprovedAmount(false);
        setIsEditingClaimDate(false);
        await getInsuranceClaimDetails(workOrderDetail?.id);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["pdf"].includes(ext)) return "pdf";
    if (["doc", "docx", "xls", "xlsx", "csv"].includes(ext)) return "doc";
    return "other";
  };

  const getImageUrl = (item) => {
    if (!item) return null;
    if (typeof item === "string") return item;
    return item?.url || item?.fileUrl || item?.path || null;
  };

  const handleImageOpen = (img, idx = 0, imagesArray = []) => {
    setImageSelection(getImageUrl(img));
    setCurrentIndex(idx);
    setCurrentImages(imagesArray);
    setOpenImage(true);
  };

  return (
    <>
      {openImage && (
        <ImagePreviewLoop
          imageSelection={imageSelection}
          openImage={openImage}
          setImageSelection={setImageSelection}
          setOpenImage={setOpenImage}
          setCurrentIndex={setCurrentIndex}
          setCurrentImages={setCurrentImages}
          currentIndex={currentIndex}
          currentImages={currentImages}
        />
      )}

      <div className="max-w-7xl mx-auto p-4">
        <div className="flex justify-between">
          {" "}
          <h2 className="text-lg font-semibold mb-4">
            Insurance Claim Details
          </h2>{" "}
          {(isEditingApprovedAmount || isEditingClaimDate) && (
            <button
              onClick={() => {
                handleUpdateInsuranceClaim();
              }}
              className="bg-yellow-600 hover:bg-yellow-700 px-6 py-2 rounded-xl text-sm"
            >
              Save
            </button>
          )}
        </div>

        {!insurancePostReponse ? (
          <>
            <form onSubmit={handleSubmit} className="grid grid-cols-3 gap-4">
              <input
                type="text"
                name="claimNumber"
                placeholder="Claim Number *"
                value={formData.claimNumber}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="text"
                name="policyNumber"
                placeholder="Policy Number *"
                value={formData.policyNumber}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="text"
                name="agentName"
                placeholder="Agent Name *"
                value={formData.agentName}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="text"
                name="isuranceProvider"
                placeholder="Isurance Provider *"
                value={formData.isuranceProvider}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="text"
                name="contactNumber"
                placeholder="Contact Number *"
                value={formData.contactNumber}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="text"
                name="contactEmail"
                placeholder="Contact Email *"
                value={formData.contactEmail}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="estimatedAmount"
                placeholder="Estimated Amount *"
                value={formData.estimatedAmount}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <input
                type="number"
                name="approvedAmount"
                placeholder="Approved Amount *"
                value={formData.approvedAmount}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <div>
                <label className="text-sm text-gray-600">Claim Date *</label>
                <input
                  type="date"
                  name="claimDate"
                  value={formData.claimDate}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              <div>
                <label className="text-sm text-gray-600">Dispurse Date *</label>
                <input
                  type="date"
                  name="dispurseDate"
                  value={formData.dispurseDate}
                  onChange={handleChange}
                  className="w-full border px-3 py-2 rounded"
                />
              </div>

              <div>
                <select
                  name="currentStatus"
                  value={formData?.currentStatus}
                  onChange={handleChange}
                  className={`border mt-6 border-gray-300 rounded-md px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition h-11 w-full border rounded-md p-2 w-full`}
                >
                  <option value="">Select Claim Status</option>
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                  <option value="In Progress">In Progress</option>
                </select>
              </div>

              <label>
                Policy Document
                <input
                  type="file"
                  name="policyDocument"
                  multiple
                  placeholder="Policy Document *"
                  onChange={(e) =>
                    handleFileChange(e.target.files, "policyDocument")
                  }
                  className="w-full border px-3 py-2 rounded"
                />
              </label>

              <label>
                Attachments
                <input
                  type="file"
                  name="attachments"
                  multiple
                  placeholder="Attachments *"
                  onChange={(e) =>
                    handleFileChange(e.target.files, "attachments")
                  }
                  className="w-full border px-3 py-2 rounded"
                />
              </label>

              <div className="flex gap-2 mt-2 flex-wrap">
                {formData.attachments?.map((file, i) => (
                  <div key={i} className="relative">
                    <img
                      src={file.url || file?.path || file?.Location || file}
                      onClick={() => {
                        handleImageOpen(
                          file.url || file?.path || file?.Location || file,
                        );
                      }}
                      alt="preview"
                      className="w-8 h-8 object-cover rounded-md border"
                    />

                    {/* <button
                      type="button"
                      onClick={() => removeImage(index, i)}
                      className="absolute -top-2 -right-2 bg-white border rounded-full text-red-500 px-1 text-xs"
                    >
                      ✕
                    </button> */}
                  </div>
                ))}

                {formData.policyDocument?.map((file, i) => (
                  <div key={i} className="relative">
                    <img
                      src={file.url || file?.path || file?.Location || file}
                      alt="preview"
                      className="w-8 h-8 object-cover rounded-md border"
                      onClick={() => {
                        handleImageOpen(
                          file.url || file?.path || file?.Location || file,
                        );
                      }}
                    />

                    {/* <button
                      type="button"
                      onClick={() => removeImage(index, i)}
                      className="absolute -top-2 -right-2 bg-white border rounded-full text-red-500 px-1 text-xs"
                    >
                      ✕
                    </button> */}
                  </div>
                ))}
              </div>

              {/* <div>
          <label className="text-sm text-gray-600">Dispersed Date *</label>
          <input
            type="date"
            name="dispersedDate"
            value={formData.dispersedDate}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div> */}
            </form>

            <button
              type="submit"
              onClick={() => {
                handleAddInsuranceClaim();
              }}
              className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 mt-4"
            >
              Submit
            </button>
          </>
        ) : (
          <>
            <div className="">
              {/* {insurancePostReponse?.map((row) => ( */}
              <div
                key={insurancePostReponse.id}
                className="bg-white shadow-md rounded-2xl p-4 border hover:shadow-lg transition"
              >
                <div className="grid grid-cols-6 gap-x-6 gap-y-3 text-sm text-gray-700">
                  <p className="font-semibold">Claim Number:</p>
                  <p>{insurancePostReponse.claimNumber || "-"}</p>

                  <p className="font-semibold">Policy Number:</p>
                  <p>{insurancePostReponse.policyNumber || "-"}</p>

                  <p className="font-semibold">Agent Name:</p>
                  <p>{insurancePostReponse.agentName || "-"}</p>

                  <p className="font-semibold">Insurance Provider:</p>
                  <p>{insurancePostReponse.isuranceProvider || "-"}</p>

                  <p className="font-semibold">Contact Number:</p>
                  <p>{insurancePostReponse.contactNumber || "-"}</p>

                  <p className="font-semibold">Contact Email:</p>
                  <p>{insurancePostReponse.contactEmail || "-"}</p>

                  <p className="font-semibold">Estimated Amount:</p>
                  <p>{insurancePostReponse.estimatedAmount || "-"}</p>

                  <p className="font-semibold">Approved Amount:</p>
                  <div>
                    {isEditingApprovedAmount ? (
                      <div className="flex">
                        <input
                          type="number"
                          value={formData?.approvedAmount}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              approvedAmount: e.target.value,
                            }))
                          }
                          // onBlur={() => setIsEditingApprovedAmount(false)} // closes on outside click
                          className="border w-28 px-2 py-1 rounded-md text-sm"
                          autoFocus
                        />
                      </div>
                    ) : (
                      <div className="flex gap-2">
                        <p className="cursor-pointer">
                          {insurancePostReponse?.approvedAmount || "-"}
                        </p>
                        <EditIcon
                          className="w-4 h-4"
                          onClick={() => {
                            setFormData((prev) => ({
                              ...prev,
                              approvedAmount:
                                insurancePostReponse?.approvedAmount,
                            }));
                            setIsEditingApprovedAmount(true);
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <p className="font-semibold">Claim Date:</p>
                  <div>
                    {isEditingClaimDate ? (
                      <div className="flex">
                        <input
                          type="date"
                          value={formData?.claimDate}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              claimDate: e.target.value,
                            }))
                          }
                          // onBlur={() => setIsEditingClaimDate(false)} // closes on outside click
                          className="border w-28 px-2 py-1 rounded-md text-sm"
                          autoFocus
                        />
                      </div>
                    ) : (
                      <div className="flex gap-2">
                        <p className="cursor-pointer">
                          {formatDate(insurancePostReponse?.claimDate) || "-"}
                        </p>
                        <EditIcon
                          className="w-4 h-4"
                          onClick={() => {
                            setFormData((prev) => ({
                              ...prev,
                              claimDate: insurancePostReponse?.claimDate
                                ? new Date(insurancePostReponse.claimDate)
                                    .toISOString()
                                    .split("T")[0]
                                : "",
                            }));
                            setIsEditingClaimDate(true);
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <p className="font-semibold">Dispersed Date:</p>
                  <p>{formatDate(insurancePostReponse.dispurseDate) || "-"}</p>
                </div>
              </div>
              {/* ))} */}
            </div>

            <div className="bg-white p-4 rounded-lg my-4">
              <p className="font-semibold">Policy Document:</p>
              <div>
                {parseImages(insurancePostReponse?.policyDocument)?.length >
                0 ? (
                  <div className="grid grid-cols-10 gap-2">
                    {parseImages(insurancePostReponse?.policyDocument).map(
                      (file, index) => {
                        const url =
                          file?.url ||
                          file?.path ||
                          file?.Location ||
                          file ||
                          "";

                        const type = getFileType(url);

                        return (
                          <div
                            key={index}
                            className="w-16 h-16 flex items-center justify-center border rounded-lg cursor-pointer bg-gray-50"
                            onClick={() =>
                              handleImageOpen(
                                url,
                                index,
                                JSON.parse(
                                  insurancePostReponse?.policyDocument,
                                ),
                              )
                            }
                          >
                            {type === "image" && (
                              <img
                                src={url}
                                alt="attachment"
                                className="w-full h-full object-cover rounded-lg"
                              />
                            )}

                            {type === "pdf" && (
                              <div className="text-red-500 text-xs font-semibold">
                                PDF
                              </div>
                            )}

                            {type === "doc" && (
                              <div className="text-blue-500 text-xs font-semibold">
                                DOC
                              </div>
                            )}

                            {type === "other" && (
                              <div className="text-gray-500 text-xs">FILE</div>
                            )}
                          </div>
                        );
                      },
                    )}
                  </div>
                ) : (
                  <p>-</p>
                )}
              </div>

              <p className="font-semibold my-4">Attachments:</p>
              <div>
                {parseImages(insurancePostReponse?.attachments)?.length > 0 ? (
                  <div className="grid grid-cols-12 gap-2">
                    {parseImages(insurancePostReponse?.attachments).map(
                      (file, index) => {
                        const url =
                          file?.url ||
                          file?.path ||
                          file?.Location ||
                          file ||
                          "";

                        const type = getFileType(url);

                        return (
                          <div
                            key={index}
                            className="w-16 h-16 flex items-center justify-center border rounded-lg cursor-pointer bg-gray-50"
                            onClick={() =>
                              handleImageOpen(
                                url,
                                index,
                                JSON.parse(insurancePostReponse?.attachments),
                              )
                            }
                          >
                            {type === "image" && (
                              <img
                                src={url}
                                alt="attachment"
                                className="w-full h-full object-cover rounded-lg"
                              />
                            )}

                            {type === "pdf" && (
                              <div className="text-red-500 text-xs font-semibold">
                                PDF
                              </div>
                            )}

                            {type === "doc" && (
                              <div className="text-blue-500 text-xs font-semibold">
                                DOC
                              </div>
                            )}

                            {type === "other" && (
                              <div className="text-gray-500 text-xs">FILE</div>
                            )}
                          </div>
                        );
                      },
                    )}
                  </div>
                ) : (
                  <p>-</p>
                )}
              </div>
            </div>

            {insuranceClaimHistories?.length > 0 && (
              <div className="overflow-x-auto mt-4">
                <table className="min-w-full border border-black rounded-lg">
                  <thead className="bg-gray-300 text-gray-600 text-sm">
                    <tr>
                      <th className="p-3 text-left border">
                        Status Changed To
                      </th>
                      <th className="p-3 text-left border">Remark</th>
                      <th className="p-3 text-left border">Created at</th>
                      <th className="p-3 text-left border">Attachment</th>
                    </tr>
                  </thead>

                  <tbody className="border border-gray-800 rounded-lg">
                    {insuranceClaimHistories?.map((claims, idx) => {
                      let attachment = [];

                      try {
                        attachment =
                          typeof claims?.attachment === "string"
                            ? JSON.parse(claims.attachment)
                            : claims?.attachment || [];
                      } catch (e) {
                        attachment = [];
                      }

                      return (
                        <tr key={idx} className="text-sm">
                          <td className="p-3 border">
                            {claims?.statusChangedTo || "-"}
                          </td>
                          <td className="p-3 border">
                            {claims?.remark || "-"}
                          </td>

                          <td className="p-3 border">
                            {formatDate(claims?.createdAt) || "-"}
                          </td>
                          <td className="p-3 border">
                            {attachment.length > 0 ? (
                              <div className="flex gap-2 flex-wrap">
                                {attachment?.map((file, index) => {
                                  const url =
                                    file?.url ||
                                    file?.path ||
                                    file?.Location ||
                                    file;

                                  return (
                                    <img
                                      key={index}
                                      src={url}
                                      onClick={() => {
                                        handleImageOpen(url);
                                      }}
                                      alt={`Attachment ${index + 1}`}
                                      className="w-16 h-16 object-cover rounded-md border hover:scale-105 transition"
                                    />
                                  );
                                })}
                              </div>
                            ) : (
                              <span className="text-gray-400">
                                No attachments
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            <div className="col-span-12 md:col-span-12 bg-white shadow-lg rounded-2xl p-6 h-full mt-4">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">
                Insurance Claims
              </h2>

              <input
                type="text"
                name="remark"
                placeholder="Remark *"
                value={formData.remark}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />

              <div>
                <select
                  name="statusChangedTo"
                  value={formData?.statusChangedTo}
                  onChange={handleChange}
                  className={`border mt-6 border-gray-300 rounded-md px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition h-11 w-full border rounded-md p-2 w-full`}
                >
                  <option value="">Select Claim Status</option>
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                  <option value="In Progress">In Progress</option>
                </select>
              </div>

              <label>
                Attachments
                <input
                  type="file"
                  name="attachmentsClaim"
                  multiple
                  placeholder="Attachments *"
                  onChange={(e) =>
                    handleFileChange(e.target.files, "attachmentsClaim")
                  }
                  className="w-full border px-3 py-2 rounded"
                />
              </label>

              <div className="flex gap-2 mt-2 flex-wrap">
                {formData.attachmentsClaim?.map((file, i) => (
                  <div key={i} className="relative">
                    <img
                      src={file.url || file?.path || file?.Location || file}
                      alt="preview"
                      onClick={() => {
                        handleImageOpen(
                          file.url || file?.path || file?.Location || file,
                        );
                      }}
                      className="w-8 h-8 object-cover rounded-md border"
                    />

                    {/* <button
                      type="button"
                      onClick={() => removeImage(index, i)}
                      className="absolute -top-2 -right-2 bg-white border rounded-full text-red-500 px-1 text-xs"
                    >
                      ✕
                    </button> */}
                  </div>
                ))}
              </div>

              <div className="flex justify-end mt-6">
                <button
                  onClick={() => {
                    handleAddInsuranceClaimHistories();
                  }}
                  className="bg-yellow-600 hover:bg-yellow-700 px-6 py-2 rounded-xl text-sm"
                >
                  Update Claim
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Insurance;
